const postForm = document.getElementById('post-form') as HTMLFormElement | null
const emailForm = document.getElementById('email-form') as HTMLFormElement | null

const submitButtonPost = postForm?.querySelector(
  'button[type="submit"]'
) as HTMLButtonElement | null
const submitButtonEmail = emailForm?.querySelector(
  'button[type="submit"]'
) as HTMLButtonElement | null

const name = document.getElementById('form-name') as HTMLInputElement | null
const co = document.getElementById('form-co') as HTMLInputElement | null
const address = document.getElementById('form-address') as HTMLInputElement | null
const postalCode = document.getElementById('form-postal-code') as HTMLInputElement | null
const city = document.getElementById('form-city') as HTMLInputElement | null
const country = document.getElementById('form-country') as HTMLInputElement | null
const website = document.getElementById('website') as HTMLInputElement | null // Honeypot field

const email = document.getElementById('contact-email') as HTMLInputElement | null
const websiteEmail = document.getElementById('website-email') as HTMLInputElement | null

let isSubmittingPost = false
let isSubmittingEmail = false

if (postForm && submitButtonPost) {
  postForm.addEventListener('submit', (e) => {
    e.preventDefault()
    if (!isSubmittingPost) {
      sendPostForm()
    }
  })
}

if (emailForm && submitButtonEmail) {
  emailForm.addEventListener('submit', (e) => {
    e.preventDefault()
    if (!isSubmittingEmail) {
      sendEmailForm()
    }
  })
}

const showError = (field: HTMLInputElement, message: string) => {
  const existingError = field.parentElement?.querySelector('.error-message')
  if (existingError) {
    existingError.remove()
  }

  field.classList.add('border-eu-red', 'border')

  const errorDiv = document.createElement('div')
  errorDiv.className = 'error-message text-eu-red text-sm mt-1'
  errorDiv.textContent = message
  field.parentElement?.appendChild(errorDiv)
}

const clearError = (field: HTMLInputElement) => {
  const existingError = field.parentElement?.querySelector('.error-message')
  if (existingError) {
    existingError.remove()
  }
  field.classList.remove('border-eu-red', 'border')
}

const clearAllErrors = () => {
  const fields = [name, address, postalCode, city, country, email]
  fields.forEach((field) => {
    if (field) {
      clearError(field)
    }
  })
}

const showSuccess = (form: HTMLFormElement, message: string = 'Tack för din prenumeration!') => {
  if (!form) {
    return
  }

  form.classList.remove('animate-pulse', 'pointer-events-none')

  form.innerHTML = `
    <div class="p-6 text-center">
      <svg class="w-16 h-16 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
      </svg>
      <h2 class="text-2xl font-semibold leading-[1.3]">${message}</h2>
    </div>
  `
}

const showGeneralError = (form: HTMLFormElement, message?: string) => {
  if (!form) {
    return
  }

  const existingError = form.querySelector('.general-error')
  if (existingError) {
    existingError.remove()
  }

  const errorDiv = document.createElement('div')
  errorDiv.className = 'general-error border border-eu-red rounded-lg p-4 mb-4'
  errorDiv.innerHTML = `
    <p class="text-eu-red">${message || 'Ett fel uppstod när formuläret skickades. Vänligen försök igen.'}</p>
  `
  form.insertBefore(errorDiv, form.firstChild)
}

const setLoadingState = (
  form: HTMLFormElement,
  button: HTMLButtonElement,
  loading: boolean,
  isPost: boolean
) => {
  if (isPost) {
    isSubmittingPost = loading
  } else {
    isSubmittingEmail = loading
  }

  if (loading) {
    form.classList.add('animate-pulse', 'pointer-events-none')
    button.disabled = true
    button.classList.add('opacity-50')
  } else {
    form.classList.remove('animate-pulse', 'pointer-events-none')
    button.disabled = false
    button.classList.remove('opacity-50')
  }
}

const sendPostForm = async () => {
  if (!postForm || !submitButtonPost) {
    return
  }

  clearAllErrors()
  setLoadingState(postForm, submitButtonPost, true, true)

  const payload = {
    name: name?.value.trim() || '',
    co: co?.value.trim() || '',
    address: address?.value.trim() || '',
    postalCode: postalCode?.value.trim() || '',
    city: city?.value.trim() || '',
    country: country?.value.trim() || '',
    website: website?.value || ''
  }

  try {
    const response = await fetch('/wp-json/eu-och-arbetsratt/v1/signup', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })

    const data = await response.json()

    if (response.ok && data.success) {
      showSuccess(postForm, 'Tack för din prenumeration!')
    } else {
      if (data.data?.errors && typeof data.data.errors === 'object') {
        const fieldMap: Record<string, HTMLInputElement | null> = {
          name,
          address,
          postalCode,
          city,
          country
        }

        Object.entries(data.data.errors).forEach(([field, message]) => {
          const inputField = fieldMap[field]
          if (inputField && typeof message === 'string') {
            showError(inputField, message)
          }
        })
      } else if (data.data?.message) {
        showGeneralError(postForm, data.data.message)
      } else {
        showGeneralError(postForm)
      }
      setLoadingState(postForm, submitButtonPost, false, true)
    }
  } catch (error) {
    console.error('Ett fel uppstod:', error)
    showGeneralError(
      postForm,
      'Något gick fel. Kontrollera din internetanslutning och försök igen.'
    )
    setLoadingState(postForm, submitButtonPost, false, true)
  }
}

const sendEmailForm = async () => {
  if (!emailForm || !submitButtonEmail) {
    return
  }

  clearAllErrors()
  setLoadingState(emailForm, submitButtonEmail, true, false)

  const payload = {
    email: email?.value.trim() || '',
    website: websiteEmail?.value || ''
  }

  try {
    const response = await fetch('/wp-json/eu-och-arbetsratt/v1/email-signup', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })

    const data = await response.json()

    if (response.ok && data.success) {
      showSuccess(emailForm, 'Tack! Din e-postadress har registrerats.')
    } else {
      if (data.data?.errors && typeof data.data.errors === 'object') {
        Object.entries(data.data.errors).forEach(([field, message]) => {
          if (field === 'email' && email && typeof message === 'string') {
            showError(email, message)
          }
        })
      } else if (data.data?.message) {
        showGeneralError(emailForm, data.data.message)
      } else {
        showGeneralError(emailForm)
      }
      setLoadingState(emailForm, submitButtonEmail, false, false)
    }
  } catch (error) {
    console.error('Ett fel uppstod:', error)
    showGeneralError(
      emailForm,
      'Något gick fel. Kontrollera din internetanslutning och försök igen.'
    )
    setLoadingState(emailForm, submitButtonEmail, false, false)
  }
}
